"use client"
import React from "react";
import { useConfig } from "@/lib/providers/ConfigProvider";
import ReactAudioPlayer from "react-audio-player";

const UralityAudio = ({ asset }) => {
  const { apiUrl } = useConfig();
  const audioId = asset.id;
  const url = apiUrl + "/api/files/" + audioId + ".mp3";
  return <ReactAudioPlayer src={url} controls />;
};
export default UralityAudio;
